import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules"; // Only Navigation is needed here if Autoplay isn't used
import "swiper/css";
import "swiper/css/navigation";
import { BUSINESS_SUBTYPES } from "@/constants"; // Assuming this path is correct
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

export const BusinessTypeSlider = ({ type, setType }) => {
  // Create refs for your custom navigation buttons
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);

  // State for the search query
  const [searchQuery, setSearchQuery] = useState("");

  const allBusinessTypes = BUSINESS_SUBTYPES.flatMap(
    (category) => category.subcategories
  );

  const baseDisplayedBusinessTypes = [
    { type: "stays", icon: "fa fa-home", label: "Stays" },
    ...allBusinessTypes,
  ];

  // Filter the displayedBusinessTypes based on the searchQuery
  const filteredBusinessTypes = baseDisplayedBusinessTypes.filter((business) =>
    business.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // This effect will run once to attach navigation, no longer needed for updates
  // We'll rely on the key prop for re-initialization
  // useEffect(() => {
  //   if (swiperRef.current && swiperRef.current.navigation) {
  //     swiperRef.current.update();
  //     swiperRef.current.navigation.update();
  //   }
  // }, [filteredBusinessTypes]); // Removed, will re-mount Swiper instead

  return (
    <div className="p-2 mt-4 absolute w-[110px] top-[17%] bg-white flex flex-col items-center rounded-md opacity-80 h-[330px]">
      {/* Search Bar */}
      <input
        type="text"
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="w-full px-2 py-1 mb-2 text-[12px] border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#8Ec639]"
        style={{ width: "100px" }} // Explicitly setting width to 100px
      />

      {/* Swiper with vertical navigation */}
      <Swiper
        // Use a key that changes when filteredBusinessTypes changes.
        // This forces the Swiper component to re-mount and re-initialize itself,
        // which correctly re-links the navigation buttons.
        key={filteredBusinessTypes.length} // Simple key based on length; can also use JSON.stringify(filteredBusinessTypes) for more robust changes
        modules={[Navigation]}
        spaceBetween={3}
        slidesPerView={4}
        direction="vertical"
        loop={false} // Keep loop as false for filtered content
        onSwiper={(swiper) => {
          // No setTimeout needed here, refs should be available on re-mount
          if (swiper.navigation) {
            swiper.params.navigation.prevEl = prevButtonRef.current;
            swiper.params.navigation.nextEl = nextButtonRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }
        }}
        className="relative h-full"
      >
        {/* Conditionally render slides */}
        {filteredBusinessTypes.length > 0 ? (
          filteredBusinessTypes.map((business, index) => (
            <SwiperSlide
              key={business.type || index}
              className="!w-auto !h-fit"
            >
              <button
                onClick={() => setType(business.type)}
                className={`flex flex-col items-center text-[11px] justify-center w-full py-2 rounded-lg ${
                  type === business.type
                    ? "bg-[#8Ec639] text-white"
                    : "bg-gray-200"
                } transition`}
              >
                <i className={`${business.icon} text-xl`}></i>
                <span
                  className={`text-[11px] leading-[11px] font-medium ${
                    type === business.type ? "text-white" : ""
                  }`}
                >
                  {business.label}
                </span>
              </button>
            </SwiperSlide>
          ))
        ) : (
          <div className="flex items-center justify-center h-full text-center text-gray-500 text-xs px-2">
            No results found.
          </div>
        )}
      </Swiper>

      {/* Navigation buttons */}
      {filteredBusinessTypes.length > 4 && (
        <>
          <button
            ref={prevButtonRef}
            className="absolute top-[35px] left-1/2 -translate-x-1/2 z-10 p-1 bg-gray-700/60 hover:bg-[#8Ec639] text-white rounded-full transition-colors duration-300 shadow-md"
            aria-label="Previous type"
          >
            <FiChevronUp className="w-4 h-4" />
          </button>

          <button
            ref={nextButtonRef}
            className="absolute bottom-[5px] left-1/2 -translate-x-1/2 z-10 p-1 bg-gray-700/60 hover:bg-[#8Ec639] text-white rounded-full transition-colors duration-300 shadow-md"
            aria-label="Next type"
          >
            <FiChevronDown className="w-4 h-4" />
          </button>
        </>
      )}
    </div>
  );
};
